import React from 'react';
import desktopImage1080 from './1080x642-desktop.jpg';
import mobileImage1080 from './1080x642-mobile.jpg';
import desktopImage1440 from './1440x856-desktop.jpg';
import desktopImage2160 from './2160x1284-desktop.jpg';
import styles from './ImagesPanorama.module.css';

export default function ImagesPanorama() {
  return (
    <section className={styles.section} aria-label="Panorama">
      <picture>
        <source media="(max-width: 767px)" srcSet={mobileImage1080} />
        <img
          src={desktopImage1440}
          srcSet={`${desktopImage1080} 1080w, ${desktopImage1440} 1440w, ${desktopImage2160} 2160w`}
          sizes="100vw"
          alt=""
          className={styles.image}
          loading="lazy"
        />
      </picture>
    </section>
  );
}
